export const navItems = [
  { name: "About", link: "#about" },
  { name: "Projects", link: "#projects" },
  { name: "Testimonials", link: "#testimonials" },
  { name: "Contact", link: "#contact" },
];

export const gridItems = [
  {
    id: 1,
    title: "I prioritize client collaboration, fostering open communication ",
    description: "",
    className: "lg:col-span-3 md:col-span-6 md:row-span-4 lg:min-h-[60vh]",
    imgClassName: "w-full h-full",
    titleClassName: "justify-end",
    img: "/b1.svg",
    spareImg: "",
  },
  {
    id: 2,
    title: "I'm very flexible with time zone communications",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-2",
    imgClassName: "",
    titleClassName: "justify-start",
    img: "",
    spareImg: "",
  },
  {
    id: 3,
    title: "My tech stack",
    description: "I constantly try to improve",
    className: "lg:col-span-2 md:col-span-3 md:row-span-2",
    imgClassName: "",
    titleClassName: "justify-center",
    img: "",
    spareImg: "",
  },
  {
    id: 4,
    title: "Tech enthusiast with a passion for development.",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-1",
    imgClassName: "",
    titleClassName: "justify-start",
    img: "/grid.svg",
    spareImg: "/b4.svg",
  },

  {
    id: 5,
    title: "Currently building a JS Animation library",
    description: "The Inside Scoop",
    className: "md:col-span-3 md:row-span-2",
    imgClassName: "absolute right-0 bottom-0 md:w-96 w-60",
    titleClassName: "justify-center md:justify-start lg:justify-center",
    img: "/b5.svg",
    spareImg: "/grid.svg",
  },
  {
    id: 6,
    title: "Do you want to start a project together?",
    description: "",
    className: "lg:col-span-2 md:col-span-3 md:row-span-1",
    imgClassName: "",
    titleClassName: "justify-center md:max-w-full max-w-60 text-center",
    img: "",
    spareImg: "",
  },
];

export const projects = [
  {
    id: 1,
    title: "AI Content Generator App",
    des: "Harnesses the power of AI to assist users in generating high-quality content across various platforms.",
    img: "/aiContentGenerator.svg",
    iconLists: [
      "/next.svg",
      "/tail.svg",
      "/ts.svg",
      "/108468352.png",
      "/c.svg",
    ],
    link: "https://nextjs-ai-conent-generator.netlify.app/",
  },
  {
    id: 2,
    title: "Home Service App",
    des: "Connect homeowners with local service providers for various home maintenance and improvement needs.",
    img: "homeServicesApp.svg",
    iconLists: [
      "/next.svg",
      "/tail.svg",
      "/ts.svg",
      "/hygraph.svg",
      "/descope.png",
    ],
    link: "https://nextjsservice-app.netlify.app/",
  },
  {
    id: 3,
    title: "React Node E-Commerce",
    des: "A seamless online shopping experience built with React for a dynamic frontend, Node.js for a powerful backend, and MongoDB for reliable database management.",
    img: "/ecomerce.svg",
    iconLists: [
      "/nodejs-icon.svg",
      "/reactjs-icon.svg",
      "/tail.svg",
      "/mongodb-icon.svg",
      "/pic_logo.svg",
    ],
    link: "/https://ecommerce-0ii0.onrender.com/",
  },
  {
    id: 4,
    title: "AI Travel Planner App",
    des: "Full-stack React Native app offering personalized travel recommendations and trip management.",
    img: "/aitravelApp.svg",
    iconLists: [
      "/react.svg",
      "/firebase-svgrepo-com.svg",
      "/google-maps-2020-icon.svg",
      "/google-gemini-icon.svg",
      "/expoio-icon.svg",
    ],
    link: "https://github.com/zahraaMeky/ai-travel-planner-app",
  },
];

export const testimonials = [
  {
    quote:
      "Zahraa's web development skills are exceptional. She turned our vision into a magnificent, functional website that exceeded our expectations. Her clear communication of complex ideas made the entire process smooth and enjoyable. She helped us build the Saudi Mustro website to display music courses on it.",
    name: "Sarah  Al Otabi",
    title: "Master's Degree Student",
  },
  {
    quote:
      "From the initial consultation to the final launch, Zahraa demonstrated a high level of professionalism and expertise. Her innovative solutions and strategic thinking helped us achieve a clothes e-commerce website for graduation project. We highly recommend her services especially if you face any difficulties in graduation.",
    name: "Bushra Al Kiyumi",
    title: "Bachelor Student ",
  },
  {
    quote:
      "I had the pleasure of learning from Zahraa in the front-end session at Udacity. Her expertise and passion for teaching were evident in every lesson. Zahraa's commitment to fostering a collaborative learning environment is invaluable. Her dedication and effort were truly appreciated, significantly enhancing my understanding of front-end.",
    name: "Amani Alkamshki",
    title: "Udacity Student",
  },
  {
    quote:
      "Studying front-end development with Zahraa at Udacity was fantastic! Her creative teaching made learning fun and engaging. Zahraa's support helped me unlock my potential and strive for excellence. She was a true inspiration, teaching valuable lessons about life and work. Thank you, Zahraa, for making a lasting impact on my success!",
    name: "Jawaher AL-Hakmani",
    title: "Udacity Student",
  },
  {
    quote:
      "Learning front-end development with Zahraa at Udacity was transformative. Her innovative teaching made the lessons exciting and effective. Zahraa's encouragement and support helped me realize my potential and strive for excellence. She was a true inspiration, and her guidance was invaluable. Thank you, Zahraa, for everything!",
    name: "Afnan Al Khayari",
    title: "Udacity Student",
  },
];

export const companies = [
  {
    id: 1,
    name: "cloudinary",
    img: "/cloud.svg",
    nameImg: "/cloudName.svg",
  },
  {
    id: 2,
    name: "appwrite",
    img: "/app.svg",
    nameImg: "/appName.svg",
  },
  {
    id: 3,
    name: "HOSTINGER",
    img: "/host.svg",
    nameImg: "/hostName.svg",
  },
  {
    id: 4,
    name: "stream",
    img: "/s.svg",
    nameImg: "/streamName.svg",
  },
  {
    id: 5,
    name: "docker.",
    img: "/dock.svg",
    nameImg: "/dockerName.svg",
  },
];
export const skills = [
  {
    id: 1,
    name: "HTML",
    img: "/html.svg",
  },
  {
    id: 2,
    name: "CSS",
    img: "/css-3.svg",
  },
  {
    id: 3,
    name: "JavaScript",
    img: "/javascript-1.svg",
  },
  {
    id: 4,
    name: "Tailwind",
    img: "/tailwind-css-2.svg",
  },
  {
    id: 5,
    name: "React",
    img: "/reactjs-icon.svg",
  },
];
export const workExperience = [

  {
    id: 1,
    title: "Full Stack Developer",
    desc: "Developed and maintained user-facing features using modern frontend and backend technologies.",
    className: "md:col-span-2",
    thumbnail: "/exp2.svg",
  },
  {
    id: 2,
    title: "Mobile App Developer",
    desc: "Designed and developed mobile app for both iOS & Android platforms using React Native.",
    className: "md:col-span-2", // change to md:col-span-2
    thumbnail: "/exp4.svg",
  },
  
  // {
  //   id: 3,
  //   title: "Freelance App Dev Project",
  //   desc: "Led the dev of a web app for a client, from initial concept to deployment on app stores.",
  //   className: "md:col-span-2", // change to md:col-span-2
  //   thumbnail: "/exp3.svg",
  // },
  // {
  //   id: 2,
  //   title: "Lead Backend Developer",
  //   desc: "Assisted in the development of a web-based platform using Next.js & Django, enhancing interactivity..",
  //   className: "md:col-span-2",
  //   thumbnail: "/exp4.svg",
  // },
  
];

export const socialMedia = [
  
  // {
  //   id: 1,
  //   img: "/twit.svg",
  //   link:""
  // },
  
  {
    id: 2,
    img: "/instagram.svg",
    link:"https://www.instagram.com/alzahraamekky/"
  },
  {
    id: 3,
    img: "/youtube.svg",
    link:"https://www.youtube.com/channel/UCvfkU6N3XoY8XAiDtSMCcqg"
  },
  {
    id: 4,
    img: "/git.svg",
    link:"https://github.com/zahraaMeky"
  },
  {
    id: 5,
    img: "/link.svg",
    link:"https://www.linkedin.com/in/engzahraa/"
  },
  {
    id: 6,
    img: "/whatsapp.svg",
    link:"https://wa.me/99495057"
  },
];
export const brainwaveServices = [
  "Planning & Strategy",
  "Execution & Progress",
  "Deployment & Launch",
];